import React, { createContext, useContext, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { wisReactieConcepten } from "@/components/afspraken/reactieUtils";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("tw1_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      localStorage.removeItem("tw1_user");
      localStorage.removeItem("tw1_token");
      return null;
    }
  });

  const login = useCallback(async (username, password) => {
    const res = await api.post("/auth/login", { username, password });
    localStorage.setItem("tw1_token", res.data.access_token);
    localStorage.setItem("tw1_user", JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(() => {
    wisReactieConcepten();
    localStorage.removeItem("tw1_token");
    localStorage.removeItem("tw1_user");
    setUser(null);
  }, []);

  const clearUsingDefault = useCallback(() => {
    setUser((u) => {
      if (!u) return u;
      const next = { ...u, usingDefault: false };
      localStorage.setItem("tw1_user", JSON.stringify(next));
      return next;
    });
  }, []);

  const finishForcedChange = useCallback(() => {
    setUser((u) => {
      if (!u) return u;
      const next = { ...u, usingDefault: false, mustChangePassword: false };
      localStorage.setItem("tw1_user", JSON.stringify(next));
      return next;
    });
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, clearUsingDefault, finishForcedChange }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
